import View from 'view/view'
import template from 'component/sidebar_search/template/sidebar_search.tmpl'
import windowView from 'shared/view/window'

const SidebarSearchView = View.extend({
    template,

    _searchFormView: null,

    defaultOptions: {
        pageTitle: 'Search',
        headline: 'Search',
    },

    events: {
        'click .js-reset-search-form': '_onResetSearchFormClick',
        'click .js-open-search-panel': '_onOpenSearchPanelClick',
        'click .js-close-search-panel': '_onCloseSearchPanelClick',
    },

    bubbleEvents: {
        'form:change': '_onSearchFormChange',
        'form:active': '_onSearchFormActive',
        'form:reset': '_onSearchFormReset',
        'form:submit': '_onSearchFormSubmit',
    },

    initialize(options) {
        this.options = this.pickOptions(options, this.defaultOptions)
    },

    render() {
        this.destroySubviews()
        let sidebarContainer

        this.$el.html(
            this.template({
                pageTitle: this.options.pageTitle,
                headline: this.options.headline,
            })
        )

        this._searchFormView = this.renderSearchForm()

        if (windowView.isMobile()) {
            sidebarContainer = '.js-search-mobile'
        } else {
            sidebarContainer = '.js-search'
        }

        this.$(sidebarContainer).append(this._searchFormView.el)

        if (this.model.get('page') === 'search') {
            this._showActiveSearch()
        } else {
            this._toggleSearchPanel(false)
        }

        return this
    },

    renderSearchForm() {
        throw new Error('Must implement `renderSearchForm` method.')
    },

    // Activating the form (changing it for the first time) only triggers search above tablet
    _onSearchFormActive() {
        this.$('.js-reset-search-form').toggleClass('is-hidden', false)
    },

    // Changing the form only triggers search above tablet
    _onSearchFormChange(model) {
        if (!windowView.isMobile()) {
            this.trigger('SearchSidebar:search', model)
        }
    },

    // Submit button triggers search below tablet
    _onSearchFormSubmit(model) {
        this.trigger('SearchSidebar:search', model)
    },

    _onSearchFormReset() {
        this.trigger('SearchSidebar:reset')
        this.$('.js-reset-search-form').toggleClass('is-hidden', true)
    },

    _onResetSearchFormClick() {
        this._searchFormView.reset()
    },

    _onCloseSearchPanelClick() {
        this._searchFormView.reset()
        this._toggleSearchPanel(false)
    },

    _onOpenSearchPanelClick() {
        this._toggleSearchPanel(true)
    },

    _showActiveSearch() {
        this._toggleSearchPanel(true)
        this.$('.js-reset-search-form').toggleClass('is-hidden', false)
    },

    _toggleSearchPanel(visible) {
        this.$('.js-search-panel').toggleClass('is-hidden', !visible)
        this.$('.js-open-search-panel').toggleClass('is-hidden', visible)
        this.$('.js-close-search-panel').toggleClass('is-hidden', !visible)
    },
})

export default SidebarSearchView
